import {  extraDataTags } from '../Config/constants.js';
import moment from 'moment';

/* Return score in [0, 50, 100] for weak, medium, strong  */
function getPasswordStrength(passwordText) {
	let score = 0;
	/*

		It must include one special symbol (: @$! % * ? &).
	*/

	//It must be at least 8char length
	if (passwordText.length < 8) {
		return score;
	}

	//It must include one lowercase letter
	if (passwordText !== passwordText.toLowerCase()) {
		score++;
	}

	//It must include one uppercase letter
	if (passwordText !== passwordText.toUpperCase()) {
		score++;
	}

	//It must have one number
	if (/\d/.test(passwordText)) {
		score++;
	}

	//It must have one special symbol
	if (/[^A-Za-z0-9]+/.test(passwordText)) {
		score++;
	}

	if (score === 4)	{
		return 100;
	}

	if (score > 1) {
		return 50;
	}

	return 0;
}

function toCurrency(value) {
	let f = new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	return f.format(value);
}

function toDecimal(value) {
	let f = new Intl.NumberFormat('it-IT', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	return f.format(value);
}

function unauthorized(error) {
	const err = error?.response?.data?.error;
	return typeof err === "string" && err.includes("unauthorized");
}

function openBlob(blobStream) {
    const blob = new Blob([blobStream], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
}

function explodeExtraData(extraData, unformatted = false) {
    if (!extraData)
        return "---";
    try {
        let extra = JSON.parse(extraData);
        let output = "";
        for (const property in extra) {
            if (property !== "customer_id") {
                let tag = extraDataTags[property].split('|');
                let prop = tag[1] === "string" ? extra[property].replaceAll(/<\/?[^>]+(>|$)/gi, "") : (tag[1] === "date" ? (extra[property] ? moment(extra[property]).format('DD/MM/YYYY') : "-") : (extra[property] ? "SI" : "NO"))
                if (unformatted)
                    output += tag[0] + ": " + prop + " - ";
                else
                    output += "<p><strong>" + tag[0] + ":</strong> " + prop + "</p>";
            }
        }
        output = output.trim();
        if (unformatted) {
            output = output.slice(0, -1).trim();
        }

        return output;
    } catch (error) {
        return "N/D";
    }
}

export function myLog(event, label = " > ") {
    const now = new Date().toLocaleString();
    let prefix = "LOG [" + now + "] " + label + ": ";

    if (typeof event === 'string') {
        console.log(prefix + event);
    }
    else {
        console.log(prefix + JSON.stringify(event));
    }
}

const Functions = {
    getPasswordStrength,
    toCurrency,
    toDecimal,
    unauthorized,
    openBlob,
    explodeExtraData,
}

export default Functions
